import { render, staticRenderFns } from "./transcript-link-fields.vue?vue&type=template&id=12ba0a88&scoped=true&"
import script from "./transcript-link-fields.vue?vue&type=script&lang=js&"
export * from "./transcript-link-fields.vue?vue&type=script&lang=js&"
import style0 from "./transcript-link-fields.vue?vue&type=style&index=0&id=12ba0a88&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba0a88",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12ba0a88')) {
      api.createRecord('12ba0a88', component.options)
    } else {
      api.reload('12ba0a88', component.options)
    }
    module.hot.accept("./transcript-link-fields.vue?vue&type=template&id=12ba0a88&scoped=true&", function () {
      api.rerender('12ba0a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/transcript-link-fields/transcript-link-fields.vue"
export default component.exports